import { associations, Relation } from "@nozbe/watermelondb";
import { field, json, relation, text } from "@nozbe/watermelondb/decorators";
import { ReceiptSettings } from "@towersystems/roam-common/lib/generated-types";
import { noopSanitizeJSON } from "../utils";
import { BaseModel } from "./Base";
import ReceiptTemplateType from "./ReceiptTemplateType";

export default class ReceiptTemplate extends BaseModel {
  static table = "receipt_template";

  static associations = associations([
    "receipt_template_type",
    { type: "belongs_to", key: "receipt_template_type_id" },
  ]);

  @text("name") name: string;

  @relation("receipt_template_type", "receipt_template_type_id")
  receiptTemplateType: Relation<ReceiptTemplateType>;

  @json("settings", noopSanitizeJSON)
  settings: ReceiptSettings;

  @field("enabled") enabled: boolean;
}
